import React from 'react';
import PropTypes from 'prop-types';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Route } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import common from 'constants/common';

const PrivateRoute = ({ component: Component, ...props }) => (
  <Route
    component={withAuthenticationRequired(Component, {
      onRedirecting: () => (
        <Loader
          className="loader fixed"
          type="Oval"
          color={common.loaderColor}
        />
      ),
    })}
    {...props}
  />
);
PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default PrivateRoute;
